"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Name = exports.AddPersonalSubscription = void 0;
const Name = exports.Name = 'add-personal-subscription';
const AddPersonalSubscription = exports.AddPersonalSubscription = Name;
//# sourceMappingURL=index.js.map